import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Respuestas guardadas (macros) del modulo de tickets. Cambian poco -> staleTime
// de 5 min, cacheado por sede. Las mutaciones invalidan la lista de la sede.

export const useRespuestas = (headquarter) =>
  useQuery({
    queryKey: ticketsKeys.respuestas(headquarter),
    queryFn: async () => {
      const data = await ticketsService.listarRespuestas({ headquarter });
      return Array.isArray(data) ? data : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 5 * 60 * 1000,
  });

export const useCrearRespuesta = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => ticketsService.crearRespuesta({ headquarter, ...body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.respuestas(headquarter) }),
  });
};

export const useActualizarRespuesta = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      ticketsService.actualizarRespuesta({ headquarter, id, ...body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.respuestas(headquarter) }),
  });
};

export const useEliminarRespuesta = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => ticketsService.eliminarRespuesta({ headquarter, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.respuestas(headquarter) }),
  });
};
